import React from 'react'
import Question from './Questions/Question'
import QuestionList from './Questions/QuestionList'
import ValidateAll from './ValidateAllBtn'

interface IProps {
  names: string[]
  responses: any
  corrections?: any
}

const FormCategoryQuestions = (props: IProps) => {
  const { names, responses, corrections } = props

  return (
    <>
      {'questionNumber' in responses ? (
        <Question
          nameKeys={names}
          response={responses}
          correction={corrections}
        />
      ) : (
        <QuestionList
          names={names}
          responses={responses}
          corrections={corrections}
        />
      )}
      <ValidateAll key={`validateAll-${names.join('-')}`} nameKeys={names} />
    </>
  )
}

export default FormCategoryQuestions
